import { useEffect, useState } from "react";
import {
    mostraAlertaError,
    mostraAlertaOk,
    mostraAlertaWarning,
} from "../../../componentes/alerts/sweetAlert";
import { AxiosImagen, AxiosPrivado } from "../../../componentes/axios/Axios";
import Dropzone from "../../../componentes/imagenes/Dropzone";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import {
    ImagenProducto,
    ProductosEditar,
    ProductosGuardar,
    ProductosListar,
    ProductosTiposListar
} from "../../../configuracion/apiUrls";
import {
    regexDescripcion,
    regexNombre,
} from "../../../configuracion/validaciones";

const ModalProducto = ({
    datos,
    token,
    setListaProductos,
    ActualizarLista,
}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [id, setId] = useState(datos ? datos.id : null);
    const [nombre, setNombre] = useState(datos ? datos.nombre : "");
    const [descripcion, setDescripcion] = useState(
        datos ? datos.descripcion : ""
    );
    const [tipo, setTipo] = useState(datos ? datos.tipo : "General");
    const [codigo, setCodigo] = useState(datos ? datos.codigo : "");
    const [precio, setPrecio] = useState(datos ? datos.precio : 0);
    const [costo, setCosto] = useState(datos ? datos.costo : 0);
    const [existencia, setExistencia] = useState(datos ? datos.existencia : 0);
    const [puntoReorden, setPuntoReorden] = useState(
        datos ? datos.puntoReorden : 0
    );
    const [impuesto, setImpuesto] = useState(datos ? datos.impuesto : "15%");
    const [estado, setEstado] = useState(
        datos ? datos.estado === "Activo" : true
    );
    const [productoTipoId, setProductoTipoId] = useState(
        datos ? datos.productoTipoId : null
    );
    const [imagenesEliminadas, setImagenesEliminadas] = useState([]);
    const [imagenes, setImagenes] = useState([]);
    const [imagenesPrevias, setImagenesPrevias] = useState([]);
    const [errorNombre, setErrorNombre] = useState(false);
    const [errorDescripcion, setErrorDescripcion] = useState(false);
    const [tiposProducto, setTiposProducto] = useState([]);

    useEffect(() => {
        if (regexNombre.test(nombre)) setErrorNombre(false);
        else setErrorNombre(true);
    }, [nombre]);

    useEffect(() => {
        if (regexDescripcion.test(descripcion)) setErrorDescripcion(false);
        else setErrorDescripcion(true);
    }, [descripcion]);

    useEffect(() => {
        if (modalIsOpen) {
            setId(datos ? datos.id : null);
            setNombre(datos ? datos.nombre : "");
            setDescripcion(datos ? datos.descripcion : "");
            setTipo(datos ? datos.tipo : "");
            setCodigo(datos ? datos.codigo : "");
            setPrecio(datos ? datos.precio : 0);
            setCosto(datos ? datos.costo : 0);
            setExistencia(datos ? datos.existencia : 0);
            setPuntoReorden(datos ? datos.puntoReorden : 0);
            setImpuesto(datos ? datos.impuesto : "15%");
            setEstado(datos ? datos.estado === "Activo" : true);
            setProductoTipoId(datos ? datos.productoTipoId : null);
            setImagenesEliminadas([]);
            setImagenes([]);
            setImagenesPrevias(
                datos.productoImagens.map(img => ({
                    id: img.id,
                    url: `${ImagenProducto}${img.imagen}`
                }))
            );    
        }
    }, [modalIsOpen, datos]);

    useEffect(() => {
        const fetchTiposProducto = async () => {
            try {
                const response = await AxiosPrivado.get(ProductosTiposListar);
                setTiposProducto(response.data);
            } catch (error) {
                console.error("Error fetching tipos de producto:", error);
            }
        };

        fetchTiposProducto();
    }, []);

    const BotonGuardar = () => {
        return (
            <button
                type="button"
                className="btn btn-success"
                onClick={guardarProducto}
            >
                Guardar
            </button>
        );
    };

    const BotonEditar = () => {
        return (
            <button
                type="button"
                className="btn btn-warning"
                onClick={editarProducto}
            >
                Editar
                <i className="fas fa-edit ml-2"/>
            </button>
        );
    };

    const guardarProducto = () => {
        if (errorNombre) {
            mostraAlertaWarning(
                "El nombre del producto debe tener entre 3 y 50 caracteres y solo puede contener letras"
            );
        } else if (errorDescripcion) {
            mostraAlertaWarning(
                "La descripción del producto debe tener entre 9 y 150 caracteres"
            );
        } else {
            try {
                var body = {
                    nombre,
                    descripcion,
                    tipo: tipo ? "General" : "Servicio",
                    codigo,
                    precio,
                    costo,
                    existencia,
                    puntoReorden,
                    impuesto,
                    estado: estado ? "Activo" : "Inactivo",
                    productoTipoId,
                    imagenesEliminadas,
                    imagenes,
                };
                AxiosPrivado.defaults.headers.common[
                    "Authorization"
                ] = `Bearer ${token}`;
                AxiosPrivado.post(ProductosGuardar, body)
                    .then((respuesta) => {
                        ActualizarLista(ProductosListar, setListaProductos);
                        mostraAlertaOk("Producto guardado correctamente");
                        setModalIsOpen(false);
                    })
                    .catch((er) => {
                        const { response } = er;
                        const msjError =
                            response?.data?.msj ||
                            response?.data?.error?.message ||
                            "Ocurrió un error desconocido.";
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                mostraAlertaError("Error en la petición");
            }
        }
    };

    const handleEliminarImagen = (idImg) => {
        const imagenAEliminar = imagenesPrevias.find((img) => img.id === idImg);
        if (imagenAEliminar) {
            setImagenesEliminadas([...imagenesEliminadas, imagenAEliminar]);
            setImagenesPrevias(imagenesPrevias.filter((img) => img.id !== idImg));
        }
    };

    const editarProducto = async () => {
        if (errorNombre || errorDescripcion) {
            mostraAlertaError("Existen errores en los datos");
            return;
        }

        try {
            const formData = new FormData();
            imagenes.forEach((file) => {
                formData.append("imagenes", file);
            });
            formData.append("imagenesEliminadas", JSON.stringify(imagenesEliminadas));
            formData.append("nombre", nombre);
            formData.append("descripcion", descripcion);
            formData.append("tipo", tipo);
            formData.append("codigo", codigo);
            formData.append("precio", precio);
            formData.append("costo", costo);
            formData.append("existencia", existencia);
            formData.append("puntoReorden", puntoReorden);
            formData.append("impuesto", impuesto);
            formData.append("estado", estado ? "Activo" : "Inactivo");
            formData.append("productoTipoId", productoTipoId);
            AxiosImagen.defaults.headers.common["Authorization"] = `Bearer ${token}`;
            const respuesta = await AxiosImagen.put(
                `${ProductosEditar}${id}`,
                formData
            );
            console.log("Respuesta:", respuesta);
            ActualizarLista(ProductosListar, setListaProductos);
            mostraAlertaOk("Producto actualizado correctamente");
            setModalIsOpen(false);
            setImagenesEliminadas([]);
        } catch (er) {
            const { response } = er;
            const msjError =
                response?.data?.msj ||
                response?.data?.error?.message ||
                "Ocurrió un error desconocido.";
            mostraAlertaError(msjError, "error");
        }
    };

    return (
        <ModalBootstrap
            titulo={datos ? "Editar Producto" : "Nuevo Producto"}
            nombreBoton={datos ? "" : "Nuevo Producto"}
            estiloBoton={datos ? "btn btn-warning" : "btn btn-info"}
            iconBoton={datos ? "fas fa-edit ml-0 text-white" : "fas fa-briefcase"}
            pie={datos ? <BotonEditar /> : <BotonGuardar />}
            modalIsOpen={modalIsOpen}
            setModalIsOpen={setModalIsOpen}
            size={"sx"}
        >
            <div className="row">
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="nombre">Nombre</label>
                        <input
                            type="text"
                            className={`form-control ${errorNombre ? "is-invalid" : ""}`}
                            id="nombre"
                            placeholder="Nombre"
                            name="nombre"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                        />
                        <span id="nombre-error" className="error invalid-feedback">
                            El nombre del producto debe tener entre 3 y 50 caracteres y solo
                            puede contener letras
                        </span>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="descripcion">Descripción</label>
                        <textarea
                            className={`form-control ${errorDescripcion ? "is-invalid" : ""}`}
                            placeholder="Escribe la descripción"
                            name="descripcion"
                            rows="3"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                        />
                        <span id="descripcion-error" className="error invalid-feedback">
                            La descripción debe tener entre 9 y 150 caracteres
                        </span>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label>Tipo producto</label>
                        <select
                            className="form-control select2bs4"
                            style={{ width: "100%" }}
                            value={tipo}
                            onChange={(e) => setTipo(e.target.value)}
                        >
                            <option value="General">General</option>
                            <option value="Servicio">Servicio</option>
                        </select>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="codigo">Código</label>
                        <input
                            type="text"
                            className="form-control"
                            id="codigo"
                            placeholder="Código de barras"
                            name="codigo"
                            value={codigo}
                            onChange={(e) => setCodigo(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="precio">Precio</label>
                        <input
                            type="number"
                            className="form-control"
                            id="precio"
                            placeholder="Precio"
                            name="precio"
                            value={precio}
                            onChange={(e) => setPrecio(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="costo">Costo</label>
                        <input
                            type="number"
                            className="form-control"
                            id="costo"
                            placeholder="Costo"
                            name="costo"
                            value={costo}
                            onChange={(e) => setCosto(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="existencia">Existencia</label>
                        <input
                            type="number"
                            className="form-control"
                            id="existencia"
                            placeholder="Existencia"
                            name="existencia"
                            value={existencia}
                            onChange={(e) => setExistencia(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="puntoReorden">Punto de Reorden</label>
                        <input
                            type="number"
                            className="form-control"
                            id="puntoReorden"
                            placeholder="Punto de Reorden"
                            name="puntoReorden"
                            value={puntoReorden}
                            onChange={(e) => setPuntoReorden(e.target.value)}
                        />
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="impuesto">Impuesto</label>
                        <select
                            className="form-control"
                            id="impuesto"
                            name="impuesto"
                            value={impuesto}
                            onChange={(e) => setImpuesto(e.target.value)}
                        >
                            <option value="15%">15%</option>
                            <option value="18%">18%</option>
                            <option value="Exento">Exento</option>
                        </select>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label>Estado</label>
                        <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                id="customSwitch3"
                                name="estado"
                                checked={estado}
                                onChange={(event) => {
                                    setEstado(event.target.checked);
                                }}
                            />
                            <label className="custom-control-label" htmlFor="customSwitch3">
                                {estado ? "Activo" : "Inactivo"}
                            </label>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="productoTipoId">Tipo de Producto</label>
                        <select
                            className="form-control"
                            id="productoTipoId"
                            name="productoTipoId"
                            value={productoTipoId}
                            onChange={(e) => setProductoTipoId(e.target.value)}
                        >
                            <option value="">Seleccione un tipo de producto</option>
                            {tiposProducto.map((tipo) => (
                                <option key={tipo.id} value={tipo.id}>
                                    {tipo.nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="form-group mt-3">
                    <label>Imágenes Actuales</label>
                    <div className="d-flex flex-wrap gap-2">
                        {imagenesPrevias.map((img) => (
                            <div
                                key={img.id}
                                className="position-relative"
                                style={{ width: "100px" }}
                            >
                                <img
                                    src={img.url}
                                    alt="Imagen previa"
                                    className="img-thumbnail"
                                    style={{
                                        cursor: "pointer",
                                        border: "2px solid transparent",
                                        transition: "all 0.3s ease-in-out",
                                    }}
                                    onClick={() => handleEliminarImagen(img.id)}
                                />
                                <button
                                    type="button"
                                    className="btn btn-danger btn-sm position-absolute"
                                    style={{
                                        top: "5px",
                                        right: "5px",
                                        borderRadius: "50%",
                                        width: "24px",
                                        height: "24px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                    onClick={() => handleEliminarImagen(img.id)}
                                >
                                    ✖
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="col-sm-12">
                    <div className="form-group">
                        <label htmlFor="imagenes">Imágenes</label>
                        <Dropzone max={5} files={imagenes} setFiles={setImagenes} />
                    </div>
                </div>
            </div>
        </ModalBootstrap>
    );
};

export default ModalProducto;